/**
 *   Generated file. Do not edit
 */

import { GPIOMode } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getGpioMode: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/variable/{variableId}/gpio-mode',
    path: '/1029/{variableId}/4',
    responseBodyDecoder: allConverters.gPIOMode,
  } as ServiceCallType<void, GPIOMode>,
};
